import React, { useEffect, useRef, useContext, useState, useMemo } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { Link } from "react-router-dom";
import "./WebProfileCard.css";

const WebProfileCard = ({ memberHeading, showStatus, Userdata }) => {
  const { language } = useContext(LanguageContext);
  const [visibleCount, setVisibleCount] = useState(4);
  const [index, setIndex] = useState(0);
  const sliderRef = useRef(null);

  useEffect(() => {
    const updateVisibleCount = () => {
      if (window.innerWidth < 768) setVisibleCount(1);
      else if (window.innerWidth < 1024) setVisibleCount(3);
      else setVisibleCount(4);
    };
    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);


  const cards = useMemo(() => {
    return [...Userdata, ...Userdata.slice(0, visibleCount)];
  }, [Userdata, visibleCount]);

  const nextSlide = () => setIndex((prev) => prev + 1);

  const prevSlide = () => {
    if (index === 0) {
      sliderRef.current.style.transition = "none";
      setIndex(Userdata.length);
      sliderRef.current.style.transform = `translateX(-${(Userdata.length * 100) / visibleCount}%)`;
      setTimeout(() => {
        sliderRef.current.style.transition = "transform 0.8s ease";
        setIndex(Userdata.length - 1);
      }, 20);
    } else {
      setIndex((prev) => prev - 1);
    }
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!sliderRef.current) return;

    const card = sliderRef.current.children[0];
    if (!card) return;

    const cardWidth = card.offsetWidth;
    const gap = 15;

    const move = index * (cardWidth + gap);
    sliderRef.current.style.transition = "transform 0.8s ease";
    sliderRef.current.style.transform = `translateX(-${move}px)`;


    if (index >= Userdata.length) {
      setTimeout(() => {
        sliderRef.current.style.transition = "none";
        sliderRef.current.style.transform = `translateX(0px)`;
        setIndex(0);
      }, 800);
    }
  }, [index, Userdata.length]);

  return (
    <div className="womencard-section">
      <h2 className="text-center mb-3">{memberHeading}</h2>
      {showStatus && (
        <p className="text-center text-success mb-4">
          Find Your Perfect Life Partner - Trusted by Families Across Kongunadu
        </p>
      )}

      <div className="slider-container">
        <div className="card-wrapper-outer">
          <div className="card-wrapper-inner" ref={sliderRef}>
            {cards.map((card, i) => (
              <div className="card-item" key={i}>
                <img
                  src={`https://kovaikongunadumatrimony.com/kkm_admin/public/assets/prof_images/${card.profile_photo_1}`}
                  alt={card.name}
                />
                <h5 className="my-2">{card.name}</h5>
                 <p>{language === "ta" ? "பதிவு எண் " : "Register Number"} : {card.profile_id}</p>
                {/* <p>
                  {language === "ta" ? "பதிவு தேதி " : "Register Date"}:
                  {(() => {
                    const dateStr = card.created_at.split(" ")[0];
                    const [year, month, day] = dateStr.split("-");
                    return `${day}-${month}-${year}`;
                  })()}
                </p> */}
                <p>{language === "ta" ? "கல்வி" : "Education"} :{" "}
                  {card.education && card.education.length > 5
                    ? card.education.substring(0, 20) + "..." : card.education}</p>
                <p>{language === "ta" ? "ராசி" : "Rasi"} : {card.rasi}</p>
                <p>{language === "ta" ? "நட்சத்திரம்" : "Natchathiram"} : {card.star}</p>
                {/* <p>{language === "ta" ? "ஜாதகம்" : "Jathagam"} : {card.jathagam}</p> */}


                <p className="mb-3">{language === "ta" ? "நகரம்" : "City"} : <b>{card.current_living_place}</b></p>


                <div className="card-buttons-row">
                  <Link to="login"><button className="card-button1">{language === "ta" ? "பார்வை" : "View"}</button></Link>
                  <button className="card-button2">{language === "ta" ? "ஜாதகம்" : "Jathagam"}</button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="arrow-container mt-4">
          <button className="arrow left" onClick={prevSlide}>❮</button>
          <button className="arrow right" onClick={nextSlide}>❯</button>
        </div>

        <div className="radio-dots">
          {Userdata.map((_, i) => (
            <span
              key={i}
              className={`dot ${index % Userdata.length === i ? "active" : ""}`}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(WebProfileCard);
